import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Icon, ICONS } from 'components/Icons';

import Problem from './Problem.png';
import Solution from './Solution.png';
import './CommunitySection.scss';

function CommunitySection() {
  return (
    <div className="community-section">
      <div className="container">
        <Row className="my-5 row-section">
          <Col xs={8} className="pr-md-5">
            <div className="header my-4">
              <Icon icon={ICONS.CHARGE} className="icon" />
              The Problem
            </div>
            <ul className="problem-list">
              <li>
                <span>
                  Our society has <b>lost trust</b> in information.
                </span>
              </li>
              <li>
                <span>
                  Traditional sources are fairly and unfairly attacked as <b>biased</b>.
                </span>
              </li>
              <li>
                <span>
                  Grassroots influencers exploit <b>extreme messages</b> to
                  carve out their audience.
                </span>
              </li>
              <li>
                <span>
                  Populists use information, true or false, as a {' '}
                  <b>weapon</b> to win sales and votes.
                </span>
              </li>
            </ul>
          </Col>
          <Col xs={4} className="image-container">
            <img src={Problem} />
          </Col>
        </Row>
        <Row className="my-5 row-section">
          <Col xs={4} className="image-container">
            <img src={Solution} />
          </Col>
          <Col xs={8} className="pl-md-5">
            <div className="header my-4">
              <Icon icon={ICONS.BULB} className="icon" />
              Our solution
            </div>
            <ul className="solution-list">
              <li>
                <span>
                  Ideas should <b>stand up to a review</b> that’s both inclusive
                  and accountable.
                </span>
              </li>
              <li>
                <span>
                  Creators should show the <b>verifiable evidence</b> that
                  supports their ideas.
                </span>
              </li>
              <li>
                <span>
                  Anyone can <b>question an idea</b>... if they know what they’re
                  talking about.
                </span>
              </li>
              <li>
                <span>
                  Topic experts should <b>review ideas</b>... in a transparent
                  and standard way.
                </span>
              </li>
            </ul>
          </Col>
        </Row>
        <div className="middle-section">
          <div className="header my-3">
            <Icon icon={ICONS.FILLED_GREEN_CHECK} className="icon" />
            Help credible ideas win!
          </div>
          <div>
            When you turn on our credibility layer, you see three things:
          </div>
        </div>
        <Row className="features">
          <Col sm={3} className="feature">
            <Icon icon={ICONS.COMMUNITY_EVIDENCE} className="icon" />
            <div className="feature-text">The Evidence</div>
            <div className="feature-sub-text">
              The evidence supporting an idea
            </div>
          </Col>
          <Col sm={3} className="feature">
            <Icon icon={ICONS.COMMUNITY_QUESTIONS} className="icon" />
            <div className="feature-text">The Questions</div>
            <div className="feature-sub-text">
              How community members questioned an idea
            </div>
          </Col>
          <Col sm={3} className="feature">
            <Icon icon={ICONS.COMMUNITY_REVIEWS} className="icon" />
            <div className="feature-text">The Reviews</div>
            <div className="feature-sub-text">
              How topic experts reviewed the idea
            </div>
          </Col>
        </Row>
        <div className="hint-section">
          <ul>
            <li>
              If you’ve done your reading and reach Level 2, you get to{' '}
              <b>question and request reviews</b> yourself.
            </li>
            <li>
              Everyone gets a chance to <b>question ideas</b> - but after
              they’ve done their reading.
            </li>
            <li>
              If you have expertise on a topic, you can give a{' '}
              <b>more thorough review</b>.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CommunitySection;
